export default __webpack_public_path__ + "/dist/images/get-1.fd943b86b5d20dfce36653146f078a22.png";